import { render } from "./TwoAxleTractorSingleAxleSemitrailer.vue?vue&type=template&id=6ddec1c6&scoped=true&ts=true"
import script from "./TwoAxleTractorSingleAxleSemitrailer.vue?vue&type=script&lang=ts"
export * from "./TwoAxleTractorSingleAxleSemitrailer.vue?vue&type=script&lang=ts"

import "./TwoAxleTractorSingleAxleSemitrailer.vue?vue&type=style&index=0&id=6ddec1c6&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\330398ee0e098db7\\LoadingSokoldok\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ddec1c6"]])

export default __exports__